import { Cache } from 'client/utils/cache';

// LRU capacity is measured in entries, not bytes.
const API_CACHE_MAX_ENTRIES = 100000;

// Use a 3-hour TTL for API responses when no TTL is provided.
const DEFAULT_TTL_MS = 3 * 60 * 60 * 1000;

export const apiCache = new Cache({ max: API_CACHE_MAX_ENTRIES, ttl: DEFAULT_TTL_MS, ttlAutopurge: true });
